import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion"
import type { FAQItem } from "@/data/tools/tools-registry"
import Heading from "@/components/layout/Heading"
import { useTranslation } from "@/lib/i18n"

type ToolFAQProps = {
  faqs: FAQItem[]
  toolName: string
}

export default function ToolFAQ({ faqs, toolName }: ToolFAQProps) {
  const { translations: t } = useTranslation()

  return (
    <section className="w-full py-12 sm:py-20 px-4 sm:px-6 border-b border-neutral-100 dark:border-white/5">
      <div className="max-w-3xl mx-auto">
        <Heading
          title={t.toolsPage.frequentlyAsked}
          highlight={<span className="gradient-text">{t.toolsPage.questionsHighlight}</span>}
          description={`${t.toolsPage.faqDescription} ${toolName}`}
          className="mb-8 sm:mb-12"
          showLine={false}
        />

        <Accordion type="single" collapsible className="w-full space-y-3 sm:space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`faq-${index}`}
              className="group overflow-hidden border border-neutral-200/80 dark:border-neutral-800 rounded-2xl bg-white dark:bg-neutral-900/60 hover:border-brand-accent/40 dark:hover:border-brand-accent/40 hover:shadow-[0_8px_30px_-10px_rgba(244,63,94,0.18)] transition-all duration-300 data-[state=open]:border-brand-accent/50 data-[state=open]:shadow-[0_8px_30px_-10px_rgba(244,63,94,0.22)]"
            >
              <AccordionTrigger className="text-left text-[15px] sm:text-base font-bold py-5 sm:py-6 px-5 sm:px-7 hover:no-underline text-neutral-900 dark:text-white [&[data-state=open]]:text-brand-accent data-[state=open]:bg-gradient-to-r data-[state=open]:from-rose-50/80 data-[state=open]:to-rose-50/20 dark:data-[state=open]:from-rose-950/20 dark:data-[state=open]:to-rose-950/5 transition-colors duration-300">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-neutral-600 dark:text-neutral-400 text-[15px] sm:text-base px-5 sm:px-7 pb-5 sm:pb-6 leading-[1.8]">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  )
}
